/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it

import { datadogRum } from '@datadog/browser-rum';
const packageJson = require('./package.json');

const configInitDataDog = {
  applicationId: process.env.DATADOG_ID_APLICATION,
  clientToken: process.env.DATADOG_CLIENT_TOKEN,
  site: 'datadoghq.com',
  service: packageJson?.name,
  env: process.env.NODE_ENV,
  trackInteractions: true,
  version: packageJson?.version,
  sessionSampleRate: 100,
  sessionReplaySampleRate: 20,
  defaultPrivacyLevel: 'mask-user-input',
  trackResources: true,
  trackLongTasks: true,
  sessionExpirationDelay: 3 * 60 * 1000,
};

datadogRum.init(configInitDataDog);

datadogRum.startSessionReplayRecording();
datadogRum.startView('Start view');